/* eslint-disable eqeqeq */
import { withStyles } from '@material-ui/core/styles';
import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid';
import Button from '@material-ui/core/Button'
import {
    MoreVert as MoreVertIcon,
    NotListedLocation as LocationOnIcon,
    DescriptionOutlined as DescriptionOutlinedIcon,
    WarningOutlined as  WarningOutlinedIcon
} from '@material-ui/icons'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as pedidoActions from '../../../reducers/pedidosReducer/actions'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { formatMoney } from '../../Common/decimalHelper'
import moment from 'moment';
import { withRouter } from "react-router";
import * as Notifications from '../../Common/notification'
import { caratulaPedido, remitoPedido } from '../../../sagas/pedidosSaga/calls';
// dateadd(day, 0, cast(getdate() as date)) SQL Store procedure

const styles = theme => ({
    rootDialog:{
        zIndex: 1250,
    },
    rootInfo:{
      zIndex: 1200,
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      boxShadow: '-5px 4px 10px #8E8E8E29',
      borderRadius: '21px',
      opacity: 1,
      padding: '0px !important',
      minWidth: '300px'
  }
})

const textStyle ={
    fontSize: '12px',
    fontWeight: '400',
    color: '#0C3653',
    lineHeight: '18px',
    fontFamily: 'Poppins'
}

const Card = ({ metadata, classes, history, fecha, turno, ...props}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showUserData, setShowUserData] = React.useState(false);
    const handleClickMenu = (event) => {
        setAnchorEl(event.currentTarget);
    }
    
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const genCaratulaPedido = async () => {
        try {
            let rawData = await caratulaPedido(metadata.idPedido)
            let blobedData = URL.createObjectURL(rawData)
            window.open( blobedData )
        }
        catch (e) 
        {
            // muestro el mensaje de error
            Notifications.showError(e.error)
        }
    }

    const genRemitoPedido = async () => {
        try {
            let rawData = await remitoPedido(metadata.idPedido)
            let blobedData = URL.createObjectURL(rawData)
            window.open( blobedData )
        }
        catch (e) 
        {
            // muestro el mensaje de error
            Notifications.showError(e.error)
        }
    }

    const { alertaUbicacion, alertaFraude, alertaFacturarIVA } = metadata;
        
    const link = () => {props.sagaGetPedidoId(metadata.idPedido); history.push('/PedidosDetalle/'+ metadata.idPedido)}
    const caratula = () => {genCaratulaPedido()}
    const remito = () => {genRemitoPedido()}

    return (
        <>
            <Row style={{margin:'12px 3px'}} onClick={() => link()}>
                
                <Col style={{
                    padding: '15px 25px',
                    cursor: 'pointer',
                    background: '#FFFFFF',
                    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
                    borderRadius: '10px',                    
                }}
                >
                    <Row style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <Col style={{
                                font:' 600 16px/16px Poppins',
                                letterSpacing: '0px',
                                color: '#0C3653',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                wordBreak: 'break-all',
                                //maxWidth: 'fit-content',
                                maxWidth: '250px',
                                flex: 1,
                        }}>
                            {`${metadata.idPedido} - ${metadata.nombre}`}
                        </Col>
                        <Row style={{marginRight: '10px'}}>
                            { alertaUbicacion && <Col><LocationOnIcon style={{color:'red',fontSize:'16px', marginRight: '5px'}}/></Col> }
                            { alertaFacturarIVA && <Col><DescriptionOutlinedIcon style={{color:'red',fontSize:'16px', marginRight: '5px'}} /></Col>}
                            { alertaFraude && <Col><WarningOutlinedIcon style={{color:'red',fontSize:'16px', marginRight: '5px'}}></WarningOutlinedIcon> </Col>}
                        </Row>
                    </Row>

                    <Row style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <Col>
                            <div style={textStyle}><div>{`${moment(metadata.fechaConfirmacion).format('DD/MM/YYYY')} - ${metadata.telefono || 'sin teléfono'}`}</div></div>
                            <div style={textStyle}>{metadata.descripcion}{metadata.formaPago ? ' - ' + metadata.formaPago : ''}</div>
                        </Col>
                        <Col style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
                            <div onClick={(e)=>{e.stopPropagation()}}>
                                <Button
                                    aria-owns={anchorEl ? 'simple-menu' : undefined}
                                    aria-haspopup="true"
                                    onClick={(e) => handleClickMenu(e)}
                                    >
                                    <MoreVertIcon />
                                </Button>
                                
                                <Menu
                                    id="simple-menu"
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={() => handleCloseMenu()}
                                >
                                    <MenuItem onClick={()=>{caratula(); handleCloseMenu();}}>Carátula</MenuItem>
                                    {( metadata.descripcion == "Preparado" || metadata.descripcion  == "Entregado") && 
                                        <MenuItem onClick={()=>{remito(); handleCloseMenu();}}>Remito</MenuItem>
                                    }
                                    {(metadata.descripcion == "Confirmado" ) && 
                                        <MenuItem onClick={()=>{remito(); handleCloseMenu();}}>Picking</MenuItem>
                                    }
                                    <MenuItem onClick={()=>{setShowUserData(true); handleCloseMenu();}}>Datos usuario</MenuItem>
                                </Menu>
                            </div>
                        </Col>
                    </Row>     
                    <Row style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>                         
                        <div style={textStyle}>{`${metadata.tipo === 0 ? 'Retira -' : 'Entrega -'} ${`${metadata.diaAbreviado} ${moment(metadata.fecha).format('DD/MM')} ${metadata.turno}`}`}</div>
                        <div style={{fontFamily: 'Poppins', fontWeight: '400', fontSize: '16px', lineHeight: '24px', color:'#0C3653'}}>{formatMoney(metadata.total)}</div>
                    </Row>     
                </Col>
            </Row>
            <Dialog
                classes={{root: classes.rootDialog, paperScrollPaper: classes.rootInfo}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth='sm'
                open={showUserData}
                fullWidth={true}
            >
                <DialogContent classes={{root: classes.rootInfo}}>
                    <Row style={{margin: '0px'}}>
                        <Col xs={12} md={12} lg={12}  style={{padding: '0px'}}>
                            <div className='containerModalQuitar'>
                                <div className='labelTitleDatosUsuario'>Datos usuario</div>
                                <div className='campoInfo'>
                                    <div className='infoClave'>Nombre y apellido:</div>
                                    <div className='infoValue'>{metadata.nombre || ''}</div>
                                </div>
                                <div className='campoInfo'>
                                    <div className='infoClave'>DNI:</div>
                                    <div className='infoValue'>{metadata.dni || ''}</div>
                                </div>
                                <div className='campoInfo'>
                                    <div className='infoClave'>Email:</div>
                                    <div className='infoValue'>{metadata.email || ''}</div>
                                </div>
                                <div className='campoInfo'>
                                    <div className='infoClave'>Teléfono:</div>
                                    <div className='infoValue'>{metadata.telefono || ''}</div>
                                </div>
                                <div className='campoInfo'>
                                    <div className='infoClave'>Dirección:</div>
                                    <div className='infoValue'>{metadata.domicilio || ''}</div>
                                </div>
                                <div className='containerButtonsQuitar'>
                                    <Button className='quitarBtn' onClick={() => setShowUserData(false)}>
                                        CERRAR
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </DialogContent>
            </Dialog>
        </>
    )
}

Card.propTypes = {
    item: PropTypes.object,
}

Card.defaultProps = {
    item: {},
} 

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
	    ...pedidoActions
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(withStyles(styles)(withRouter(Card)))